export default axios => ({
  commentMarks: (photoId, payload) => axios.get(`defining-point-images/${photoId}/comments`, payload),
  updateCommentMarks: (photoId, payload) => axios.post(`defining-point-images/${photoId}/comments`, payload)
});
